import strings from 'rise-ui/config/strings.js';
import { minDate, maxDate } from 'rise-ui/config/time-series/query-params.js';

import { formatDate, parseDate } from 'rise-ui/utils/date.js';

export function timeSeriesDate(value) {
  return value === minDate ? strings['first-datum']
    : value === maxDate ? strings['last-datum']
    : (value && formatDate(parseDate(value), 'short') || '');
}
export default timeSeriesDate;
